import React from 'react'
import style from './LayoutHeader.module.scss'
import logo from './../../../assets/images/logo.png';

export function LayoutHeader(props: {children: React.ReactNode}) {
  return (
    <div className={style.container}>
        <div className={style.header}>
            <img src={logo} alt='logo'/>
            <div>
                <h2>Momap</h2>
                <label>Make Memories Together</label>
            </div>
        </div>
        {props.children}
    </div>
  )
}
